import { cloudinaryURL, cloudName } from "../constants/constants";
import axios from 'axios';

const unsignedUploadPreset = 'ml_default';

export const uploadFile = async (file) => {
  try {
    var url = `${cloudinaryURL}${cloudName}/image/upload`;
    var fd = new FormData();
    fd.append('upload_preset', unsignedUploadPreset);
    fd.append('tags', 'browser_upload'); // Optional - add tag for image admin in Cloudinary
    fd.append('file', file);
    let response = await axios.post(url, fd);
    if (response.status == 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    return null;
  }

}